(function () {
  if (window.__downloadFileSizeInit) return;
  window.__downloadFileSizeInit = true;

  var sizeCache = new Map();

  function formatBytes(bytes) {
    if (!bytes) return '';
    var format = function (value, unit) {
      return value.toFixed(1).replace(/\.0$/, '') + unit;
    };
    if (bytes >= 1073741824) return format(bytes / 1073741824, 'GB');
    if (bytes >= 1048576) return format(bytes / 1048576, 'MB');
    if (bytes >= 1024) return format(bytes / 1024, 'KB');
    return bytes + 'B';
  }

  function resolveUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function typeFromUrl(url) {
    var path = resolveUrl(url).split('?')[0].split('#')[0];
    var name = path.split('/').pop() || '';
    var ext = name.indexOf('.') === -1 ? '' : name.split('.').pop().toUpperCase();
    if (ext === 'JPEG') ext = 'JPG';
    if (ext.length >= 2 && ext.length <= 5) return ext;
    return '';
  }

  function typeFromContentType(contentType) {
    var type = (contentType || '').toLowerCase();
    if (type.indexOf('pdf') !== -1) return 'PDF';
    if (type.indexOf('zip') !== -1) return 'ZIP';
    if (type.indexOf('dwg') !== -1 || type.indexOf('acad') !== -1) return 'DWG';
    if (type.indexOf('jpeg') !== -1) return 'JPG';
    if (type.indexOf('png') !== -1) return 'PNG';
    if (type.indexOf('image/') !== -1) return 'IMAGE';
    return '';
  }

  function fetchMeta(url) {
    var resolved = resolveUrl(url);
    if (!resolved) return Promise.resolve({ bytes: 0, type: '' });
    if (sizeCache.has(resolved)) return Promise.resolve(sizeCache.get(resolved));
    var storageKey = 'resource-bytes:' + resolved;
    try {
      var cached = window.sessionStorage.getItem(storageKey);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed && typeof parsed === 'object') {
          sizeCache.set(resolved, parsed);
          return Promise.resolve(parsed);
        }
        var cachedBytes = Number(cached);
        var value = { bytes: cachedBytes, type: '' };
        sizeCache.set(resolved, value);
        return Promise.resolve(value);
      }
    } catch (error) {
      // ignore
    }
    return fetch(resolved, { method: 'HEAD', mode: 'cors' })
      .then(function (response) {
        var value = {
          bytes: Number(response.headers.get('content-length')) || 0,
          type: typeFromContentType(response.headers.get('content-type'))
        };
        sizeCache.set(resolved, value);
        try {
          window.sessionStorage.setItem(storageKey, JSON.stringify(value));
        } catch (error) {
          // ignore
        }
        return value;
      })
      .catch(function () {
        return { bytes: 0, type: '' };
      });
  }

  function hydrate() {
    document.querySelectorAll('.system-download-card').forEach(function (card) {
      var sizeEl = card.querySelector('[data-download-filesize]');
      var typeEl = card.querySelector('[data-download-filetype]');
      var url = card.getAttribute('data-download-url') || card.getAttribute('href') || '';
      if (!url || url.indexOf('/blogs/') !== -1) return;

      var hasSize = sizeEl && sizeEl.textContent.trim();
      var hasType = typeEl && typeEl.textContent.trim();
      if (!hasType) {
        var urlType = typeFromUrl(url);
        if (urlType && typeEl) {
          typeEl.textContent = urlType;
          card.setAttribute('data-download-format', urlType);
          hasType = true;
        }
      }
      if (hasSize && hasType) return;

      fetchMeta(url).then(function (meta) {
        if (!hasSize && meta.bytes) {
          var label = formatBytes(meta.bytes);
          if (!sizeEl) {
            var wrap = card.querySelector('.system-download-card__meta');
            if (!wrap) return;
            sizeEl = document.createElement('span');
            sizeEl.className = 'system-download-card__size';
            sizeEl.setAttribute('data-download-filesize', '');
            wrap.appendChild(sizeEl);
          }
          sizeEl.textContent = label;
          card.setAttribute('data-download-size', label);
        }
        if (!hasType) {
          var nextType = meta.type || typeFromUrl(url) || 'PDF';
          if (!typeEl) {
            var metaEl = card.querySelector('.system-download-card__meta');
            if (!metaEl) return;
            typeEl = document.createElement('span');
            typeEl.className = 'system-download-card__format';
            typeEl.setAttribute('data-download-filetype', '');
            metaEl.insertBefore(typeEl, metaEl.firstChild);
          }
          typeEl.textContent = nextType;
          card.setAttribute('data-download-format', nextType);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
